import './App.css';
import React, {Suspense, lazy} from 'react'
import {Route} from 'react-router-dom';
import LazyLoading from './LazyLoading';
const Index = lazy(()=> import('./Components/index.jsx'));
function App() {
  return (
    <React.Fragment>
      <div className='App'>
        <Suspense fallback={<LazyLoading/>}>
          <Route exact path={'/'} render={() => <Index/>}/>
        </Suspense>
      </div>
    </React.Fragment>
  );
}

export default App;